import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { ReviewBar } from '../ReviewBar/ReviewBar';
import { ReviewBarPropsData } from '../ReviewBar/ReviewBar.types';
import { ReviewBarsProps } from './ReviewBars.types';

export const ReviewBars = ({
  microcopy,
  onFilterReviews,
  reviewList,
  className,
}: ReviewBarsProps) => {
  const BAR_VALUES = [5, 4, 3, 2, 1];

  return (
    <div className={c('flex flex-col gap-1', className)}>
      {BAR_VALUES.map((value: number) => {
        const review = reviewList.find(
          (r: ReviewBarPropsData) => r.value === value
        );

        return (
          <ReviewBar
            key={`review-bar-${value}`}
            onFilterReviews={onFilterReviews}
            value={value}
            max={5}
            review={review ? review.review : 0}
            microcopy={{
              rating: interpolateStringWithData(microcopy.rating, {
                rating: value,
              }),
              ratings: interpolateStringWithData(microcopy.ratings, {
                rating: value,
              }),
              ariaLabel: interpolateStringWithData(microcopy.ariaLabel, {
                reviews: review ? review.review : 0,
              }),
              ratingAriaLabel: microcopy.ratingAriaLabel,
            }}
          />
        );
      })}
    </div>
  );
};
